const publicVapidKey =
  "BGFPzmcmt02CCZr44MpqrASfoCBaUiVOnyyxTMuPssIqNcc_ZQ_lwiyLwi1dGPyjepXdjtVmQsz8FLq-d5inLFA";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

function getOSInfo() {
  const userAgent = navigator.userAgent;

  if (/android/i.test(userAgent)) return { name: "Android" };
  if (/iphone|ipad|ipod/i.test(userAgent)) return { name: "iOS" };
  if (/windows/i.test(userAgent)) return { name: "Windows" };
  if (/mac/i.test(userAgent)) return { name: "macOS" };

  return { name: "Unknown" };
}

export async function subscribeUser(userId, userIdNvarchar) {
  if (!("serviceWorker" in navigator)) {
    alert("Service Worker not supported");
    return;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return;

  const registration = await navigator.serviceWorker.register(
    "/service-worker.js"
  );

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
  });

  const keys = subscription.toJSON().keys;

  const os = getOSInfo();

  const finalObject = {
    Subscription_Id: 0,
    User_Id: userId,
    EndPoint: subscription.endpoint,
    SubDateTime: new Date().toISOString(),
    p256dh: keys.p256dh,
    auth: keys.auth,
    UserIdNvarchar: userIdNvarchar,
    OsName: os.name,
    OsVersion: ""
  };

  console.log("Sending object:", finalObject);

  // await fetch("/Notifications/Post_Subscriptions", {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json"
  //   },
  //   body: JSON.stringify(finalObject)
  // });

  // alert("Notification Activated ✅");
}
